import React from 'react'
import Lottie from 'lottie-react'
import { useTranslation } from 'react-i18next'
import { APPROVE_STATUS } from '../ModalStatus/types'
import { statusMap } from './constants'
import animationData from './rotate_loading_purple.json'
import instantAnimationData from './rotate_loading.json'
import {
  StyledModalStatus,
  StyledModalStatusIcon,
  StyledModalStatusText,
} from './styled'
import { ModalStatusProps } from './types'
import { TRADE_TYPE } from '~/components/TradeDetail/types'

const ModalStatus = (props: ModalStatusProps) => {
  const { t } = useTranslation()
  const { status, statusText, tradeType = TRADE_TYPE.STAKING } = props
  const getStatus = () => {
    if (statusMap[status]) {
      return {
        icon: statusMap[status].icon,
        content: statusText || t(statusMap[status].content),
      }
    }
    return { icon: '', content: '' }
  }
  const { icon, content } = getStatus()
  const animation =
    tradeType === TRADE_TYPE.STAKING ? animationData : instantAnimationData

  const renderIcon = () => {
    if (
      status === APPROVE_STATUS.APPROVING ||
      status === APPROVE_STATUS.UN_APPROVING
    ) {
      return (
        <Lottie
          animationData={animation}
          loop
          style={{
            width: 28,
            height: 28,
            lineHeight: '20px',
          }}
        />
      )
    }
    return <StyledModalStatusIcon src={icon} alt="" />
  }

  return (
    <StyledModalStatus>
      <StyledModalStatusText>{content}</StyledModalStatusText>
      {renderIcon()}
    </StyledModalStatus>
  )
}

export default ModalStatus
